import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="fields-array"
export default class extends Controller {
    static targets = ["inputs"]

    initialize() {
        this.field = this.element.dataset.field;
    }

    add() {
        // check if the last input is empty
        const inputs = this.inputsTarget.querySelectorAll("input");
        const last = inputs[inputs.length - 1];
        if (last.value === "") {
            return;
        }

        // create a new input
        const field = document.createElement("input");
        field.setAttribute("type", "text");
        field.setAttribute("name", `course[${this.field}][]`);
        field.classList.add("w-full", "p-2", "border", "rounded");
        this.inputsTarget.appendChild(field);
    }
}
